import React, { Component, useState } from "react";

export const Email = ({ confirm }) => {
  const [email, setEmail] = useState("");
  return (
    <div className="card-body">
      <div className="row">
        <input
          className="form-control"
          type="email"
          onChange={(e) => setEmail(e.target.value)}
          inputMode="numeric"
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
          placeholder="abc@abc.com"
        ></input>
      </div>
      <div className="row justify-content-end pt-1 mr-0">
        <button
          className="btn btn-primary"
          style={{ backgroundColor: "#203e60" }}
          onClick={() => confirm(email)}
        >
          Confirmar
        </button>
      </div>
    </div>
  );
};
